export function TypeDescription(data) {
    const { id, comment: description, link, typeUniformFiles: files } = data;

    return {
        id,
        description: description || "",
        link: link || "",
        files: (files || []).map((file) => {
            const { id, name } = file;

            return {
                id,
                url: name,
                name: name.split("/").pop(),
            };
        }),
        hasDescription: description || link || (files && files.length),
    };
}

export function TypeModel(data) {
    const { form_view, id, parent_id, is_archive, responsible_id, manufacturer, model } = data;
    return {
        parentId: `${parent_id}`,

        id: `${id}`,
        name: form_view,
        producer: manufacturer,
        model,
        responsible: responsible_id || null,
        isArchive: is_archive,
        descriptionModel: TypeDescription(data),
    };
}

export function formatTypeModel(data) {
    const { name, parentId, producer, model, responsible, description, link, files, oldFiles } = data;

    return {
        form_view: name,
        parent_id: parentId,
        model,
        manufacturer: producer,
        responsible_id: responsible,
        comment: description,
        link,
        files,
        oldFiles,
    };
}

export function updateTypeModel(typeModel, data) {
    const { name, parentId, descriptionModel, producer, model, responsible } = data;
    typeModel.name = name;
    typeModel.parentId = parentId;
    typeModel.producer = producer;
    typeModel.model = model;
    typeModel.responsible = responsible;
    typeModel.descriptionModel = descriptionModel;

    return typeModel;
}
